import { Injectable, inject } from '@angular/core';
import { catchError, of } from 'rxjs';
import { PublicContentApiService } from '../api/public-content-api.service';
import { CompanyInfoResponse } from '../models/openapi-admin-extended.model';
import { DEFAULT_PUBLIC_COMPANY } from '../models/public-content.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PortalBrandingService {
  private readonly publicContent = inject(PublicContentApiService);

  initialize(): void {
    this.publicContent.company().pipe(catchError(() => of(DEFAULT_PUBLIC_COMPANY)))
      .subscribe((company) => this.applyCompany(company));
  }

  applyCompany(company: CompanyInfoResponse): void {
    const logo = this.resolve(company.agrisolLogoUrl) || 'assets/img/agrisol-logo.png';
    const favicon = this.resolve(company.agrisolFaviconUrl) || 'assets/img/agrisol-favicon.png';
    const authImage = this.resolve(company.agrisolAuthImageUrl);
    this.applyAssets(logo, favicon, authImage);
  }

  private applyAssets(logo: string, favicon: string, authImage: string | null): void {
    if (typeof document === 'undefined') return;
    document.documentElement.style.setProperty('--portal-logo-image', this.cssUrl(logo));
    document.documentElement.style.setProperty('--portal-auth-image', authImage ? this.cssUrl(authImage) : 'none');
    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = favicon;
    const appleTouchIcon = document.querySelector<HTMLLinkElement>("link[rel='apple-touch-icon']");
    if (appleTouchIcon) appleTouchIcon.href = favicon;
  }

  private resolve(path?: string | null): string | null {
    if (!path) return null;
    if (/^(https?:|data:|blob:|assets\/)/i.test(path)) return path;
    return `${environment.mediaBaseUrl}${path.startsWith('/') ? '' : '/'}${path}`;
  }

  private cssUrl(url: string): string {
    return `url("${url.replace(/["\\]/g, '\\$&')}")`;
  }
}
